// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"938ffef3","455":"0ee5a87f","977":"f3abc02b"}[chunkId] + ".chunk.js";
};